import * as Sentry from '@sentry/gatsby'
import { Integrations } from '@sentry/tracing'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://00c09745a9bed5d1b0e5feb7bda4b39d@sentry-new.euw2.devops-algbra.com/7',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  })
}
